<div class="footer-section" [ngClass]="{'justify-content-center': centerAlign}">
  <div class="empty-wrapper" *ngIf="!centerAlign"></div>
  <nav class="pagination-nav d-flex align-items-center gap-3">
    <!-- Page Number Navigation -->
    <ul class="pagination mb-0">
      <!-- Back Button -->
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button
          class="btn page-link arrow-btn"
          style="border-radius: 10px; cursor: pointer"
          (click)="previousPage()"
        >
          <span>
            <img
              src="../../../../assets/images/mingcute_right-fill.svg"
              alt=""
              style="transform: rotate(180deg)"
            />
          </span>
        </button>
      </li>

      <!-- Page Numbers -->
      <li class="page-item" *ngFor="let page of pagesToShow; trackBy: trackById">
        <span *ngIf="page === -1" class="page-link">...</span>
        <button
          *ngIf="page !== -1"
          class="btn page-link"
          style="cursor: pointer"
          [ngClass]="{ 'active-page': page === currentPage }"
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>
      </li>

      <!-- Next Button -->
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button
          class="btn page-link arrow-btn"
          style="border-radius: 10px; cursor: pointer"
          (click)="nextPage()"
        >
          <span><img src="../../../../assets/images/mingcute_right-fill.svg" alt="" /></span>
        </button>
      </li>
    </ul>

    <!-- Page Size Dropdown (Dropup) -->
    <ng-container *ngIf="showPageSize">
      <span>Records per page</span>
      <div class="dropdown dropup" [class.show]="isDropdownOpen" style="position: relative">
        <button
          class="btn dropdown-toggle-custom d-flex justify-content-between align-items-center"
          style="min-width: 125px; height: 45px; border: 1px solid #dee2e6"
          type="button"
          aria-expanded="false"
          (click)="isDropdownOpen = !isDropdownOpen"
        >
          {{ itemsPerPage }}
          <img
            src="/assets/images/dropdown_icon.svg"
            [class.rotated]="isDropdownOpen"
            style="margin-left: 8px; transition: transform 0.3s ease"
          />
        </button>

        <ul
          class="dropdown-menu dropdown-menu-end"
          [class.show]="isDropdownOpen"
          style="bottom: 100%; top: auto"
        >
          <li *ngFor="let pageSize of pageSizes; trackBy: trackById">
            <a class="dropdown-item" (click)="setItemsPerPage(pageSize)">
              {{ pageSize }}
            </a>
          </li>
        </ul>
      </div>
    </ng-container>
  </nav>
  <div class="result-count" *ngIf="showRecordCount">
    <span class="count">
      Showing {{ startRecord }} to {{ endRecord }} of {{ totalRecords }} records
    </span>
  </div>
</div>
